module.exports = __webpack_public_path__ + "img/game_main_pc_243_off.f8ab177c.png";